import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Box,
    Paper,
    Button,
    CircularProgress,
    Stack
} from '@mui/material';
import { Phone as PhoneIcon } from '@mui/icons-material';
import { useNotification } from '../contexts/NotificationContext';
import { useAuth } from '../contexts/AuthContext';
import ProfileView from '../components/profile/ProfileView';
import ProfileForm from '../components/profile/ProfileForm';
import PhoneVerification from '../components/auth/PhoneVerification';

function Profile() {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const { userProfile, updateProfile, loading, checkPhoneVerification } = useAuth();
    const [isEditing, setIsEditing] = useState(false);
    const [showPhoneVerification, setShowPhoneVerification] = useState(false);

    // AuthContextからuserProfileが取得できない場合のみローディング表示
    if (loading || !userProfile) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // プロフィール更新の処理
    const handleSubmit = async (data) => {
        try {
            await updateProfile({ profile: data });
            setIsEditing(false);
            showNotification('プロフィールを更新しました', 'success');
        } catch (error) {
            console.error('プロフィール更新エラー:', error);
            showNotification('プロフィールの更新に失敗しました', 'error');
        }
    };

    // 電話番号認証成功時の処理
    const handlePhoneVerificationSuccess = async () => {
        await checkPhoneVerification();
        showNotification('電話番号認証が完了しました', 'success');
    };

    return (
        <Container maxWidth="md">
            <Box sx={{ mb: 2 }}>
                <Stack direction="row" spacing={2}>
                    <Button
                        variant="contained"
                        onClick={() => setIsEditing(!isEditing)}
                    >
                        {isEditing ? 'キャンセル' : 'プロフィールを編集'}
                    </Button>

                    {!userProfile.phoneVerified && (
                        <Button
                            variant="outlined"
                            startIcon={<PhoneIcon />}
                            onClick={() => setShowPhoneVerification(true)}
                            color="primary"
                        >
                            電話番号認証
                        </Button>
                    )}
                </Stack>
            </Box>

            {isEditing ? (
                <ProfileForm
                    initialData={userProfile.profile}
                    onSubmit={handleSubmit}
                />
            ) : (
                <ProfileView user={userProfile} />
            )}

            <PhoneVerification
                open={showPhoneVerification}
                onClose={() => setShowPhoneVerification(false)}
                onSuccess={handlePhoneVerificationSuccess}
            />
        </Container>
    );
}

export default Profile; 